import { ItandiIllust } from "@itandi/brand-ui/ItandiIllust";
import Styles from "./VendorWithoutAuthHeader.module.scss";

export function VendorWithoutAuthHeader() {
	return (
		<header className={Styles.BBHeader} id="header">
			<nav className={Styles.FirstNav}>
				<span className={Styles.ItandiBBLogo}>
					<ItandiIllust variant="itandiLogo" />
				</span>
			</nav>
		</header>
	);
}
